/** @jsx jsx */
import { jsx } from '@emotion/core';
import { GetProfileModel } from './profileFormModel';
import { useState } from 'react';
import { useForm } from '../../../form';
import { Button, usePost, ErrorMessage } from '../../../components';
import env from '../../../env';
import style from './style';

export function Profile({tippingSession, logOUt}){
  
  const model = GetProfileModel({});
  const form = useForm(model, { usePlaceholder: true });
  const render = (name) => form.renderControl(name, null);
  const [sendingStatus, setSendingStatus] = useState(null);
  const post = usePost();

  const onSubmit = ((e) => {
    form.validateForm(e, () => {
      const formData = { ...form.getValue(), token : tippingSession };
      post.send(env.apiBase + "/api/proxy/tippingprofile", formData);
      setSendingStatus('pending');
    });
  });

  if (post.done() && sendingStatus === 'pending') {
    //const _data = post.response;
    //console.log("_data", _data);
    // setTimeout(() => {
    // }, 1000);
    form.reset(model);
    setSendingStatus(null);
  }

  if(post.hasErrors()){
    let checkSessionExpired = false;
    for(let i in post.errors){
      if(post.errors[i] === "session expired"){
        checkSessionExpired = true;
        break;
      }
    }

    setTimeout(() => {
      setSendingStatus(null);
      if(checkSessionExpired === true){
        logOUt();
      }
    }, 1000);
  }

  return(
    <div className="tipping__profile__form" style={{marginTop:'1rem'}}>
      <h4 style={{marginBottom: '0.5rem'}}> Profile </h4>
      <div className="row">
        <div className="col-12 col-md-6">
          {render('firstName')}
        </div>
        <div className="col-12 col-md-6">
          {render('lastName')}
        </div>
        <div className="col-12 col-md-6">
          {render('nickName')}
        </div>
        <div className="col-12 col-md-6">
          {render('phone')}
        </div>
        <div className="col-12" style={{textAlign:'center'}}>
          
          <div className="actions" css={style.button__container}>
            <Button onClick={onSubmit} status={post.status}> SUBMIT </Button>
          </div>
          
          <ErrorMessage errors={form.errors} summaryMessage="Please review the errors." />
          <ErrorMessage errors={post.errors} />
          {post.done() && <span style={{marginLeft: '1.5rem', color:'red', fontWeight: 'bold'}}> Successfully Save!</span>}

        </div>
      </div>
    </div>
  )
}